import React, { useState }  from "react";
import { createPortal } from 'react-dom';

import { ScreenshotGuest } from "./ScreenshotGuest";
import { Screenshot } from "./Screenshot";
import ScreenshotModal from "./ScreenshotModal";
import { Grid2, Box } from "@mui/material/";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { Card, Button,  Image, Text, Group, Avatar, Badge, ActionIcon, useMantineTheme } from '@mantine/core';
import { Tooltip } from '@mantine/core';


import { useObjectStore } from "../zustand/objects";

const OtherUser = ({ isMobile, other, open, socketId, update }) => {

// const {isOtherPreviewOpen, setIsOtherPreviewOpen} = useObjectStore()

const [isOtherPreviewOpen, setIsOtherPreviewOpen] = useState(false)
const [hover, setHover] = useState(false)

const switchIsPreviewOpen = () => {
  setIsOtherPreviewOpen(!isOtherPreviewOpen)
} 

// console.log(other)
const handleWatchClick = () => {
//  isWatching ? setIsWatching(false) : setIsWatching(true)
switchIsPreviewOpen()
// setIsOtherPreviewOpen()
}

// NEED TO MOVE PREVIEW ELSEWHERE SO IT CAN STAY OPEN WHEN USER CHANGES TABS

 
  const [maximised, setMaximised] = useState(false)

  const openMaximisedClick = () => { 
    setMaximised(true)
  } 

  const closeMaximisedClick = () => {
    setMaximised(false)
  }

  const theme = useMantineTheme();

  return (

    <Grid2 mt={1} container style={{ width: "auto", minHeight: 20, maxHeight: 140 }}>
      {!isOtherPreviewOpen ? <>
        <Grid2 item xs={10}>
          <Text fw={400} size='xs' >
            <AccountCircleIcon   fontSize="small" style={{ marginRight: 2 }}  />
            {update.cursor && update.cursor.name} {update.preview && update.preview.name}
            {` | `}
            {update.cursor && update.cursor.artboard}
            {update.preview && update.preview.artboard}
          </Text></Grid2>
        <Grid2 item xs={2}>{update.preview &&
          <Text fw={400} size='xs' c={"#424242"} c={!hover ? "#424242" : "#868e96"}
            onPointerOver={() => setHover(true)}
            onPointerLeave={() => setHover(false)}
            style={{ marginLeft: 10 }}>
            <Tooltip label="See user view">
              <VisibilityIcon 

                fw={400} size='xs'
                style={{ cursor: 'pointer' }} fontSize="small"
                onClick={() => handleWatchClick()} /></Tooltip></Text>}</Grid2> </>
        : maximised ?
          update.preview && <ScreenshotModal closeMaximisedClick={closeMaximisedClick} cameraGuest={update.preview} artboard={update.preview.artboard} name={update.preview.name} id={socketId} />
          : update.preview && isOtherPreviewOpen && <div>
            <Grid2 item xs={12}>

              <div style={{ position: 'absolute', bottom: 58, height: 132, right:-10, width: 250, marginRight: 20, borderRadius: 5, border: 'solid #DEE2E6', overflow: "hidden" }}>

                <Group bg={'none'} style={{ position: 'absolute', right: 5, zIndex: 99999 }}>

                  <div style={{ position: 'absolute', right: 60, top: 85, width: '100%' }}>
                    <Text fw={400} size='xs' c={"#424242"} >
                      {/* <AccountCircleIcon color={!hover ? "#424242" : "#868e96"} fontSize="small" style={{ marginRight: 5 }} />{update.preview && update.preview.name} {` | `} */}
                      {/* {update.preview && update.preview.artboard} */}
                    </Text></div>
                  <Text>
                    <FullscreenIcon fontSize="small" onClick={openMaximisedClick} style={{ marginLeft: 115, marginRight: 5, cursor: 'pointer' }} />
                    <CloseIcon fontSize="small" onClick={handleWatchClick} style={{ cursor: 'pointer' }} />
                  </Text>
                </Group>

                {update.preview && <ScreenshotGuest openMaximisedClick={openMaximisedClick} cameraGuest={update.preview} artboard={update.preview.artboard} id={socketId} />}
              </div>
            </Grid2>

          </div>

      }
    </Grid2>
  )
}

      export default OtherUser